/* jshint esversion: 6 */

/**
 * IFrameAPIService is a class that manages communication between an iframe and its parent window.
 * It initializes services and registers listeners for message events.
 */
class IFrameAPIService {
    /**
     * Constructs an instance of IFrameAPIService.
     * @param {Object} $window - The global window object.
     * @param {Object} $injector - AngularJS injector service.
     * @param {Object} ConfigAPIService - Service for handling configuration data.
     */
    constructor($window, $injector, ConfigAPIService) {
        this.window = $window;
        this.injector = $injector;
        this.ConfigAPIService = ConfigAPIService;
        this.is_init = false;
        this.allowed_services = [{
            'service': 'ResponseAPIService',
            'methods': ['get', 'get_multiple', 'set', 'has', 'update_status']
        }, {
            'service': 'ConfigAPIService',
            'methods': ['get_config', 'register_listener']
        }];
    }

    /**
     * Initializes the IFrameAPIService.
     * @param {Object} task_info - Information about the task to initialize.
     * @param {boolean} [force=false] - Whether to force reinitialization.
     */
    init(task_info, force = false) {
        if (!this.is_init || force) {
            this.ConfigAPIService.init(task_info);
            this.register_listener();
            this.is_init = true;
        }
    }

    /**
     * Registers a listener for message events from the parent window.
     */
    register_listener() {
        const self = this;

        this.window.addEventListener('message', function(event) {
            if (typeof event.data !== 'undefined') {
                let found = false;
                self.allowed_services.forEach(function (value) {
                    if (value.service === event.data[0]) {
                        if (value.methods.includes(event.data[1])) {
                            found = true;
                            console.log("Found: ", event.data[0], event.data[1]);
                        }
                    }
                });
                console.log(found ? "Found" : "Not Found", event);
                let result;
                if (found) {
                    const service = self.injector.get(event.data[0]);
                    const params = event.data[2];
                    params.push(event);

                    result = service[event.data[1]].apply(service, params);
                }
                
                if (typeof result !== 'undefined') {
                    event.source.postMessage([result, event.data[3]], event.origin);
                }
            }
        }, false);
    }
}

export default IFrameAPIService;